import { RecentlyViewed } from '@theme/recently-viewed-products';

class RgRecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const run = () => this.loadProducts();

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      window.setTimeout(run, 120);
    }
  }

  async loadProducts() {
    const currentProductId = this.dataset.currentProductId;
    const maxProducts = Number.parseInt(this.dataset.maxProducts || '4', 10);
    const productIds = RecentlyViewed.getProducts()
      .filter((id) => id && id !== currentProductId)
      .slice(0, maxProducts);

    if (productIds.length === 0) {
      this.hidden = true;
      return;
    }

    try {
      const url = new URL(Theme.routes.search_url, window.location.origin);
      url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('section_id', 'rg-recently-viewed-products');

      const response = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recently viewed products could not be loaded.');

      const markup = await response.text();
      const parsedMarkup = new DOMParser().parseFromString(markup, 'text/html');
      const source = parsedMarkup.querySelector('[data-rg-recently-viewed-results]');
      const target = this.querySelector('[data-rg-recently-viewed-results]');

      if (!source || !target || source.children.length === 0) {
        this.hidden = true;
        return;
      }

      target.replaceChildren(...Array.from(source.children));
      this.hidden = false;
    } catch (error) {
      this.hidden = true;
    }
  }
}

if (!customElements.get('rg-recently-viewed-products')) {
  customElements.define('rg-recently-viewed-products', RgRecentlyViewedProducts);
}
